import { Injectable } from '@angular/core';
import { User } from '../../../shared/models/user';
import { lastValueFrom, Subscription } from 'rxjs';
import { AuthenticationService } from '../authentication/authentication.service';
import { ClientService } from '../client/client.service';
import { ConfigService } from '../config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoaderService } from '../loader/loader.service';
import { APIEndPoints } from 'src/app/shared/APIEndPoints';
//import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {
  currentUser: User;
  currentUserSubscription: Subscription;

  selectedClient: any;
  selectedClientSubscription: Subscription;
  //private readonly secretKey = 'usEr@73912345678';Add commentMore actions
  //private readonly iv = CryptoJS.enc.Utf8.parse('0000000000000000'); // Fixed IV for consistency with backend

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private authenticationService: AuthenticationService,
    private clientService: ClientService,
    private loaderService: LoaderService
  ) {

    this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
      this.currentUser = user;
    });

    this.selectedClientSubscription = this.clientService.selectedClient.subscribe(client => {
      this.selectedClient = client;
    });
  }


  securityApiUrl = this.configService.apiUri;

  convertIdToRoleNames(roleIds: number[]) {
    const roles = this.configService.azmanRoles;
    const roleNames = [];
    roleIds.forEach(roleId => {
      roleNames.push(roles[roleId]);
    });
    return roleNames;
  }

  getPermissions(username: string, roles: string[],showSpinner = true) {
    if (showSpinner) {
      this.loaderService.show();
    }
    return this.http.post<any>(
      this.securityApiUrl + APIEndPoints.getPermissionsWithClients + username, roles);
  }

  getVendors(username: string, isInternalAdmin: boolean) {
    return this.http.post<any>(
      this.securityApiUrl + APIEndPoints.getVendorList + '?username=' + username + '&isInternalAdmin=' + isInternalAdmin, {});
  }

  getUserDetails(username: string) {
    return this.http.get<any>(`${this.securityApiUrl + APIEndPoints.getUserDetails}${username}`);
  }

  async getClientPermissions(clientNum: number): Promise<any> {
    this.loaderService.handleSpinner(true);
    const roles = this.currentUser.profile.Roles;
    return await lastValueFrom<any>(
      this.http.post<any>(
        this.securityApiUrl + APIEndPoints.GetClientTilesPermissions +
        this.currentUser.profile.UserName,
        {
          ClientNum: clientNum,
          Roles: roles,
        }
      )
    ).finally(() => this.loaderService.handleSpinner(false))
  }
  canAccessLink(name: string) {
    const blocks = name.split('/');

    blocks.forEach((block, index) => {
      blocks[index] = block.trim().replace(' ', '');
    });

    if (blocks.length === 1) {
      return this.currentUser.profile.Permissions[blocks[0]] !== undefined;
    } else if (blocks.length === 2) {
      const allowed = (this.currentUser.profile.Permissions[blocks[0]] !== undefined);
      if (Array.isArray(this.currentUser.profile.Permissions[blocks[0]])) {
        return allowed && this.currentUser.profile.Permissions[blocks[0]].indexOf(blocks[1]) > -1;
      } else if (typeof this.currentUser.profile.Permissions[blocks[0]] === 'object') {
        return this.currentUser.profile.Permissions[blocks[0]] !== undefined
          && this.currentUser.profile.Permissions[blocks[0]][blocks[1]] !== undefined;
      }
    } else if (blocks.length === 3) {
      return this.currentUser.profile.Permissions[blocks[0]] !== undefined
        && this.currentUser.profile.Permissions[blocks[0]][blocks[1]] !== undefined
        && this.currentUser.profile.Permissions[blocks[0]][blocks[1]].indexOf(blocks[2]) > -1;
    }

    return false;
  }

  canAccess(blockObj: any): Boolean {
    const name = blockObj.permission;
    const defaultTxt = blockObj.default || '';

    if (!this.currentUser) { return; }

    const userType = this.currentUser.profile.UserType.toLowerCase();

    if (name.indexOf('WaiverManagement / ') > -1) {
      return true;
    }

    if (!this.selectedClient && name.indexOf('WaiverManagement / ') > -1) {
      if (defaultTxt.indexOf('check') > -1) {
        return this.canAccessLink(name);
      }
      return defaultTxt.indexOf(userType) > -1;
    }

    return this.canAccessLink(name);
  }

}
